/*
 * action types
*/
export const SET_ERROR = 'SET_ERROR'
export const AUTH_SUCCESS = 'AUTH_SUCCESS'
export const AUTH_ERROR = 'AUTH_ERROR'
export const INIT = '@@INIT'
export const LOCATION_CHANGE = '@@router/LOCATION_CHANGE'
export const FETCH_CONTACT = 'FETCH_CONTACT'
export const UPDATE_CONTACT = 'UPDATE_CONTACT'
export const SET_CONTACT = 'SET_CONTACT'
export const SAVE_CONTACT = 'SAVE_CONTACT'
export const SAVE_SUBSCRIPTION = 'SAVE_SUBSCRIPTION'
export const FETCH_CONTACTS = 'FETCH_CONTACTS'
export const UPDATE_CONTACTS = 'UPDATE_CONTACTS'
export const SET_CONTACTS = 'SET_CONTACTS'
export const ADD_CONTACTS = 'ADD_CONTACTS'
export const SAVE_DEACTIVATE = 'SAVE_DEACTIVATE'
export const SAVE_EMAIL = 'SAVE_EMAIL'
export const CONFIRM_PROFILE = 'CONFIRM_PROFILE'
export const FETCH_EXCLUSIONS = 'FETCH_EXCLUSIONS'
export const SET_EXCLUSIONS = 'SET_EXCLUSIONS'
export const SAVE_EXCLUSIONS = 'SAVE_EXCLUSIONS'
export const FETCH_EMAIL_PREFERENCES = 'FETCH_EMAIL_PREFERENCES'
export const SET_EMAIL_PREFERENCES = 'SET_EMAIL_PREFERENCES'
export const UPDATE_EMAIL_PREFERENCES = 'UPDATE_EMAIL_PREFERENCES'
export const SAVE_EMAIL_PREFERENCES = 'SAVE_EMAIL_PREFERENCES'
export const FETCH_DATABASE_PREFERENCES = 'FETCH_DATABASE_PREFERENCES'
export const SET_DATABASE_PREFERENCES = 'SET_DATABASE_PREFERENCES'
export const SAVE_DATABASE_PREFERENCES = 'SAVE_DATABASE_PREFERENCES'
export const FETCH_FILTER_RESULTS = 'FETCH_FILTER_RESULTS'
export const SET_FILTER_RESULTS = 'SET_FILTER_RESULTS'
export const DISMISS_FIRST_TIME_HELP = 'DISMISS_FIRST_TIME_HELP'

/*
 * action creators
*/
export const fetchContact = emailAddress => ({ type: FETCH_CONTACT, payload: { emailAddress } })
export const updateContact = contact => ({ type: UPDATE_CONTACT, payload: { contact } })
export const saveContact = contact => ({ type: SAVE_CONTACT, payload: { contact } })
export const saveSubscription = subscriptionUpdates => ({ type: SAVE_SUBSCRIPTION, payload: { subscriptionUpdates } })
export const fetchContacts = emailAddress => ({ type: FETCH_CONTACTS, payload: { emailAddress } })
export const updateContacts = contacts => ({ type: UPDATE_CONTACTS, payload: { contacts } }) // 2018-11-02: doesn't look to be used
export const addContacts = addContactsRequest => ({ type: ADD_CONTACTS, payload: { addContactsRequest } })
export const saveDeactivate = deactivateRequest => ({ type: SAVE_DEACTIVATE, payload: { deactivateRequest } })
export const saveEmail = emailChangeRequest => ({ type: SAVE_EMAIL, payload: { emailChangeRequest } })
export const confirmProfile = (contact, contactIsChanged) => ({ type: CONFIRM_PROFILE, payload: { contact, contactIsChanged } })
export const fetchExclusions = emailAddress => ({ type: FETCH_EXCLUSIONS, payload: { emailAddress } })
export const saveExclusions = (emailAddress, exclusions) => ({ type: SAVE_EXCLUSIONS, payload: { emailAddress, exclusions } })
export const fetchEmailPreferences = emailAddress => ({ type: FETCH_EMAIL_PREFERENCES, payload: { emailAddress } })
export const updateEmailPreferences = emailPreferences => ({ type: UPDATE_EMAIL_PREFERENCES, payload: { emailPreferences } })
export const saveEmailPreferences = (emailAddress, emailPreferences) => ({ type: SAVE_EMAIL_PREFERENCES, payload: { emailAddress, emailPreferences } })
export const fetchDatabasePreferences = emailAddress => ({ type: FETCH_DATABASE_PREFERENCES, payload: { emailAddress } })
export const saveDatabasePreferences = (url, id, preferences) => ({ type: SAVE_DATABASE_PREFERENCES, payload: { url, id, preferences } })
export const fetchFilterResults = (emailAddress, filterIndex) => ({ type: FETCH_FILTER_RESULTS, payload: { emailAddress, filterIndex } })
export const setFilterResults = (filterIndex, results) => ({ type: SET_FILTER_RESULTS, payload: { filterIndex, results } })
export const dismissFirstTimeHelp = () => ({ type: DISMISS_FIRST_TIME_HELP })
